<template>
  <div>
    <div v-bind="props.attrs">
      
      <component :is="state.bannerComponent"></component>

      <slot />
      <div ref="itemsRef" :class="`quick-promotion-list ${prepare.dataTheme}`">
        <component 
          v-for="item in state.items" 
          :key="item.id" 
          class="quick-promotion-item card" 
          :is="item"
          @update:cart="updateCart"
          @choose:assort="onPromotionChooseAssort"
          @choose:assortPromotion="onPromotionChooseAssort"
        ></component>
      </div>
    </div>

    <!-- 加購商品 -->
    <div v-if="state.showAddon">
      <h3 class="text-center mt-4">🌟加購品🌟</h3>
      
      <AddonProductListVertical 
        v-if="state.showAddon"
        fields="assorts,assorts.image_url" 
        search_from="carts" 
        search_title="購物車"
        search_path="購物車>加購商品" 
        :black-list="cartData.carts" 
        :store-data="storeData"
        :currency-symbol="cartData.currency_symbol" 
        :limit="5" 
        hide-header 
        @refresh:carts="updateCart" 
      />
    </div>

    <div v-if="!!state.promotion">
      <div class="d-flex flex-wrap justify-content-between align-items-center my-4">
        <span class="block text-center text-2xl font-semibold">
        目前已經選購 ({{ cartCount }}) 件商品
        </span>
        <a class="btn btn-primary btn-login-register" href="/login">
        登入/註冊會員，可方便您管理訂單
        <i class="fa fa-chevron-right ml-2"></i>
        </a>
      </div>

      <ProductCarts is-bundle />

      <CheckoutLoginDialog />
      <CheckoutFormDialog is-bundle /> 
      <hr />
    </div>

    <!-- 商品詳情 -->
    <PromotionProductQuickView
      v-if="state.prodVisible"
      v-model="state.prodVisible"
      :product="modalState.item"
      :is-distribute="isDistribute"
      :assort-detail="assortDetail"
      :store-data="storeData"
      @show="handleShowItem"
    />
  </div>
</template>
<script setup>
import { reactive, computed, ref, toRaw, onMounted, h, createVNode, render, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n"
import { useVModel } from "@vueuse/core"
import {
  _api_getPromotionInfo,
} from "../../../api/index.js";
import _ from "lodash";
import {
  notificationErrors,
  currencyFormat,
  assignCartCount,
  clearCartCount,
  dataTranslations,
  breakpoint,
  isBundlePromotionType,
  lookupAliasTranslations,
  dashToHump,
  imgProxy,
} from "../../../utils";
import CheckoutLoginDialog from "../../lites/CheckoutLoginDialog.vue"
import CheckoutFormDialog from "../../lites/CheckoutFormDialog.vue"
import ProductCarts from "../../lites/ProductCarts.vue"
import AddonProductListVertical from "../../products/AddonProductListVertical.vue"
import PromotionProductQuickView from "../../promotions/PromotionProductQuickView.vue"
import { ElButton, ElImage } from 'element-plus'
import { renderHtml, getAttributesFromNode } from "../../../plugins/html-to-vue/index.js";

const props = defineProps({
  attrs: Object,
})

const emit = defineEmits(["update:cart", "choose:assortPromotion", "choose:assort"]);

const { t, locale } = useI18n()

const store = useStore();
const storeData = computed(() => store.getters["lite/storeData"]);
const loginUserId = computed(() => store.getters["lite/userData"]?.id);
const cartData = computed(() => store.getters["lite/cartData"]);
const cartCount = computed(() => store.getters['lite/cartCount']);
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart)
const distributorData = computed(() => store.getters["lite/distributorData"]);
const isDistribute = computed(() => !!distributorData.value?.id)

const elemObj = ref(null)
const firstTemplate = ref(null)

const state = reactive({
  showAddon: false,
  prodVisible: false,
  promotion: null,
  bannerComponent: null,
  items: [],
})

const itemsRef = ref()
const noneImg = "https://img.aib.tw/builderjs-editor/static/image/square.png"

const prepare = computed(() => {
  const dataSets = {}
  // console.debug("prepare", props)
  for (let value in props.attrs) {
    if (["style", "class"].includes(value)) {
      continue
    }
    const textArr = dashToHump(value);
    dataSets[textArr] = aibTrackers.isNumber(props.attrs[value]) ? Number(props.attrs[value]) : props.attrs[value]
  }
  const params = {
    fields: "whitelisted_store_products,whitelisted_store_categories,whitelisted_store_promotions,whitelisted_store_promotion_groups,discountable_store_products,discountable_store_categories,blacklisted_store_products,materials,page",
  };
  dataSets['params'] = params

  return dataSets
})

const getStorePromotionInfo = async () => {
  store.dispatch("lite/setFullPageLoading", true);
  try {
    state.promotion = await _api_getPromotionInfo(prepare.value.dataSourceManualIds, prepare.value.params)
  } catch (error) {
    notificationErrors(error);
  } finally {
    store.dispatch("lite/setFullPageLoading", false);
  }
}

const parseTemplate = (rawHtml, item) => {
  const conf = {
    config: {
      container: {
        type: 'div'
      },
      extraComponentsMap: {
        banner: {
          conditions(node) {
            return (
              node.type === 'tag' && // is a tag
              node.name === 'img' && // is an anchor
              node.attrs?.class?.match(/promotion-banner-image\s?/) // has btn class
            )
          },
          renderer(node, children, context) {
			      const options = getAttributesFromNode(node)
            const image_url = context?.image_url ? context?.image_url : noneImg
            const width = itemsRef.value?.clientWidth ? itemsRef.value?.clientWidth : 1000
            const height = width / 2
            // console.debug("imgProxy", imgProxy(image_url, 'fill:300:300:1'))
            return h(
              ElImage,
              {
                class: options.class,
                style: options.style,
                fit: "cover",
                alt: options.attrs?.alt,
                // loading: 'lazy',
                src: imgProxy(options.attrs.src, `fill:${width+50}:${height+50}:1`),
              },
              () => [...children] 
            )
          }
        },
        imgLink: {
          conditions(node) {
            return (
              node.type === 'tag' && // is a tag
              node.name === 'div' && // is an anchor
              node.attrs?.class?.match(/card-img-top\s?/) // has btn class
            )
          },
          renderer(node, children, context) {
			      const options = getAttributesFromNode(node)
            const image_url = context?.image_url ? context?.image_url : noneImg
            // console.debug("一頁式", imgProxy(image_url, 'fill:300:300:1'))
            return h(
              ElImage,
              {
                class: options.class,
                style: options.style,
                fit: "cover",
                alt: context?.name,
                loading: 'lazy',
                src: imgProxy(image_url),
                // src: image_url,
                onClick: (e) => {
                  e.stopPropagation()
                  // console.debug("emit_event", context?.id)
                  if (context?.id) {
                    handleQuickView(context)
                  }
                }
              },
              () => [...children] 
            )
          }
        },
        btnBuy: {
          conditions(node) {
            return (
              node.type === 'tag' && // is a tag
              node.name === 'button' && // is an anchor
              node.attrs?.class?.match(/btn-view-product\s?/) // has btn class
            )
          },
          renderer(node, children, context) {
			      const options = getAttributesFromNode(node)
            return h(
              ElButton,
              {
                // disabled: !context?.assorts.length,
                class: options.class,
                style: options.style,
                title: context?.name,
                type: "primary",
                size: "large",
                onClick: (e) => {
                  e.stopPropagation()
                  // console.debug("emit_event", context?.id)
                  if (context?.id) {
                    onProductChooseAssort(context?.id)
                  }
                }
              },
              () => [...children]
            )
          }
        }
      },
      textTransformer: text => text.trim()
    },

    rawHtml: rawHtml,
  }
  return renderHtml(conf.rawHtml, conf.config, item)
}

const getTemplate = (item) => {
  if (!firstTemplate.value) {
    return;
  }
  // let elem = firstTemplate.value;
  let elem = firstTemplate.value.clone(true);
  
  const salePrice = item?.discounted_price ? item?.discounted_price : item?.sale_price;

  $(elem).attr('data-id', item?.id);
  $(elem).find('.card-title').text(item?.name);
  $(elem).find('.card-img-top').attr('alt', item?.name);
  $(elem).find('.btn-view-product').attr('title', item?.name);
  // $(elem).find('.card-img-top').attr('src', item?.image_url);
  $(elem).find('.sale-price').text(salePrice)
  
  if (item?.comm_price) {
    $(elem).find('.delete-price span').text(item?.comm_price);
    $(elem).find('.delete-price').show()
  } else {
    $(elem).find('.delete-price').hide()
    $(elem).find('.delete-price span').text('')
  }
  
  return parseTemplate($(elem).html(), item)
  // return elem;
}

const loadStorePromotionInfo = async () => {
  // console.debug("prepare", prepare.value)
  // console.debug("elemObj", elemObj.value)
  
  if (!prepare.value.dataSourceManualIds || prepare.value.dataSourceManualIds == "0") {
    elemObj.value.text('尚未設定活動來源!');
    elemObj.value.attr('class', 'text-danger h1');
    return;
  }
  
  await getStorePromotionInfo();

  const lang = prepare.value.lang;
  const title = dataTranslations(state.promotion?.title_translations, lang);
  // console.debug("promotion", state.promotion)
  
  // let list = elemObj.value.find('.quick-promotion-list');
  // 取得個別群組的範本
  if (!firstTemplate.value) {
    firstTemplate.value = elemObj.value.find('.quick-promotion-item').first().clone(true);
  }
  // 刪除空範本
  elemObj.value.find('.sample-block .quick-promotion-list').remove()
  // list.html('');
  if (!!prepare.value?.dataTypeBadge) {
    elemObj.value.find('.promotion-type-text').text(prepare.value?.dataTypeBadge);
  }
  elemObj.value.find('.promotion-title-text').text(title);
  if (!!state.promotion?.whitelisted_store_products && !!state.promotion?.whitelisted_store_products.length) {
    
    await state.promotion.whitelisted_store_products.forEach((item, idx) => {
      item.name = dataTranslations(item.name_translations, lang);
      let template = getTemplate({...item});
      state.items.push(template)
      // list.append(template);
    })
    // 監聽按鈕點擊
    // listenClick(list.find('.quick-promotion-item'));
  }
}
const handleShowItem = async (item) => {
  onProductChooseAssort(item.id)
}

const onProductChooseAssort = (id) => {
  // 開啟選擇規格視窗
  onPromotionChooseAssort(id)
  // emit("choose:assort", id)
}
const onPromotionChooseAssort = (id) => {
  // 開啟選擇規格視窗
  // console.debug("開啟選擇規格視窗", {id, promotion: toRaw(state.promotion)})
  emit("choose:assortPromotion", {id, promotion: toRaw(state.promotion)})
  // emit("choose:promotion", {id, promotion: toRaw(state.promotion)})
}
const listenClick = (templates) => {
  // console.log("監聽按鈕點擊:", toRaw(templates))
  templates.each((idx, el) => {
    const template = $(el)
    const itemId = template.attr('data-id');
    const btns = template.find(".btn-view-product");
    btns.each((btnIdx, btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        let item = state.promotion.whitelisted_store_products.find((el) => el.id.toString() == itemId);
        if (item) {
          handleBtnClick(item?.id);
        }
      });
    })
  })
  // 非會員登入按鈕
  const btn = $(".btn-login-register")
  if (loginUserId.value) {
    btn.hide()
  } else {
    btn.attr("onclick", "javascript:location.href='/login'")
  }
}

const updateCart = () => {
  emit("update:cart")
}

const assortDetail = ref(true)
const modalState = reactive({
  title: "",
  item: null,
  visible: false,
})
const handleQuickView = async (data, select_assort_btn = true, promotion = null) => {
  assortDetail.value = select_assort_btn
  if (promotion) {
    state.promotion = promotion
  }
  modalState.title = dataTranslations(data.name_translations);
  modalState.item = data;
  state.prodVisible = true
}

onMounted(() => {
  if (typeof prepare.value.id !== 'undefined') {
    elemObj.value = $("#"+prepare.value.id);
    // console.debug("prepare.id", elemObj.value)
    // 隱藏html, 改用vue元件取代
    elemObj.value.find('.login-register-block').attr('style', 'display: none !important;')
    elemObj.value.find('.cart-empty').remove()
    elemObj.value.find('.cart-block').remove()
    elemObj.value.find('.addon-block').remove()
    
    loadStorePromotionInfo();
    state.showAddon = prepare.value?.dataDisplayAddon == "1"

    const banner = elemObj.value.find('.promotion-title-block')
    if (banner) {
      state.bannerComponent = parseTemplate(banner.html(), prepare.value)
      banner.remove()
    }
  }
})
</script>
